<template>
  <div :class="[`sva-poslovna-resenja-na-jednom-mestu`, className || ``]">
    <div class="text-14">
      <div class="sva-poslovna-resenja-na-jednom-nestu">
        <div class="frame-6">
          <p class="sva-poslovna-resenja-na-jednom-mestu-1 inter-semi-bold-link-water-24px">
            sva poslovna rešenja na jednom mestu
          </p>
          <p class="inter-normal-gull-gray-18px">
            odaberite digitalne servise i napravite svoj poslovni ekosistem
          </p>
          <p class="inter-normal-gull-gray-18px">
            protokol prati vaš razvoj i raste sa vašim poslovnim potrebama
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SvaPoslovnaResenjaNaJednomMestu",
  props: ["className"],
};
</script>

<style>
.sva-poslovna-resenja-na-jednom-mestu {
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;
}

.text-14 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  position: relative;
}

.sva-poslovna-resenja-na-jednom-nestu {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 1px 0px;
  position: relative;
  width: 331px;
}

.frame-6 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 280px;
  justify-content: center;
  position: relative;
}

.sva-poslovna-resenja-na-jednom-mestu-1 {
  align-self: stretch;
  height: 115px;
  letter-spacing: -0.5px;
  line-height: 50px;
  position: relative;
  text-align: center;
}

.excepteur-sint-occae-2 {
  align-self: stretch;
  height: 105.27px;
  min-width: 305.96px;
  position: relative;
}

.sva-poslovna-resenja-na-jednom-mestu.sva-poslovna-resenja-na-jednom-mestu-2 {
  left: 0;
}

.sva-poslovna-resenja-na-jednom-mestu.sva-poslovna-resenja-na-jednom-mestu-2 .excepteur-sint-occae-2 {
  align-self: unset;
}
</style>
